import { PillItem, TabItem } from '@indigo-ag/component-module';
import i18next from 'core/i18n';

import { text as textUtils } from 'shared/utils/text.util';

export enum TabIds {
  BACKGROUND_CHECK = 'BACKGROUND_CHECK',
  CREDIT_ANALYSIS = 'CREDIT_ANALYSIS',
  COLLATERAL_ANALYSIS = 'COLLATERAL_ANALYSIS',
  DOCUMENT_REGISTRATION = 'DOCUMENT_REGISTRATION',
  DOCUMENT_REGISTRATION_SECRETARY = 'DOCUMENT_REGISTRATION_SECRETARY',
  INVESTMENT_FUND_ASSIGNMENT = 'INVESTMENT_FUND_ASSIGNMENT',
  ALL = 'ALL',
  CONFIRMED_NEGOTIATIONS = 'CONFIRMED_NEGOTIATIONS',
  DOCUMENT_REGISTRATION_EXTERNAL = 'DOCUMENT_REGISTRATION_EXTERNAL',
  CREDIT_LEAD_REPORT_INITIAL_ANALYSIS = 'CREDIT_LEAD_REPORT_INITIAL_ANALYSIS',
  CREDIT_LEAD_REPORT_COMMERCIAL = 'CREDIT_LEAD_REPORT_COMMERCIAL',
  CREDIT_LEAD_FORMALIZATIONS = 'CREDIT_LEAD_FORMALIZATIONS',
  CREDIT_LEAD_REJECTED = 'CREDIT_LEAD_REJECTED',
  CREDIT_LEAD_MONITORING = 'CREDIT_LEAD_MONITORING'
}

export enum HiddenTabIds {
  LEAD = 'LEAD',
  EXTERNAL_CREDIT = 'EXTERNAL_CREDIT',
  TERRAMAGNA = 'TERRAMAGNA'
}

export interface TabConfig {
  internal: TabItem<TabIds>[];
  secretary: TabItem<TabIds>[];
  creditLead: TabItem<TabIds>[];
  creditLeadReport: TabItem<TabIds>[];
  external: TabItem<TabIds>[];
  externalLegal: TabItem<TabIds>[];
}

export const TABS_CONFIG: TabConfig = {
  internal: [
    {
      id: TabIds.BACKGROUND_CHECK,
      title: i18next.t('backgroundCheck_title')
    },
    {
      id: TabIds.CREDIT_ANALYSIS,
      title: i18next.t('creditAnalysis')
    },
    {
      id: TabIds.COLLATERAL_ANALYSIS,
      title: i18next.t('collateralAnalysis')
    },
    {
      id: TabIds.DOCUMENT_REGISTRATION,
      title: i18next.t('documentRegistration')
    },
    {
      id: TabIds.ALL,
      title: i18next.t('all')
    }
  ],
  secretary: [
    {
      id: TabIds.DOCUMENT_REGISTRATION_SECRETARY,
      title: i18next.t('documentRegistration')
    }
  ],
  creditLead: [],
  creditLeadReport: [
    {
      id: TabIds.CREDIT_LEAD_REPORT_INITIAL_ANALYSIS,
      title: textUtils.firstLetterUppercase(i18next.t('initialAnalysis'))
    },
    {
      id: TabIds.CREDIT_LEAD_REPORT_COMMERCIAL,
      title: textUtils.firstLetterUppercase(i18next.t('needsDocumentation'))
    },
    {
      id: TabIds.CREDIT_LEAD_FORMALIZATIONS,
      title: textUtils.firstLetterUppercase(i18next.t('formalizations'))
    },
    {
      id: TabIds.CREDIT_LEAD_MONITORING,
      title: textUtils.firstLetterUppercase(i18next.t('monitoring'))
    },
    {
      id: TabIds.CREDIT_LEAD_REJECTED,
      title: textUtils.firstLetterUppercase(i18next.t('rejected'))
    }
  ],
  externalLegal: [
    {
      id: TabIds.CONFIRMED_NEGOTIATIONS,
      title: textUtils.firstLetterUppercase(i18next.t('confirmedNegotiations'))
    },
    {
      id: TabIds.DOCUMENT_REGISTRATION_EXTERNAL,
      title: textUtils.firstLetterUppercase(i18next.t('documentRegistration'))
    }
  ],
  external: []
};

export enum PillIds {
  // Lead
  LEAD_IN_BACKGROUND_CHECK = 'LEAD_IN_BACKGROUND_CHECK',
  LEAD_IN_ANALYSIS = 'LEAD_IN_ANALYSIS',
  LEAD_IN_FORMALIZATION = 'LEAD_IN_FORMALIZATION',
  // Internal
  BACKGROUND_CHECK_PENDING = 'BACKGROUND_CHECK_PENDING',
  BACKGROUND_CHECK_SENT = 'BACKGROUND_CHECK_SENT',
  BACKGROUND_CHECK_MANAGERIAL_APPROVAL = 'BACKGROUND_CHECK_MANAGERIAL_APPROVAL',
  CREDIT_ANALYSIS_PENDING = 'CREDIT_ANALYSIS_PENDING',
  CREDIT_ANALYSIS_IN_PROGRESS = 'CREDIT_ANALYSIS_IN_PROGRESS',
  CREDIT_ANALYSIS_AWAITING_APPROVAL = 'CREDIT_ANALYSIS_AWAITING_APPROVAL',
  CREDIT_ANALYSIS_WITH_COMMERCIAL = 'CREDIT_ANALYSIS_WITH_COMMERCIAL',
  CREDIT_ANALYSIS_PHASE_APPROVAL = 'CREDIT_ANALYSIS_PHASE_APPROVAL',
  CREDIT_ANALYSIS_AWAITING_COMMERCIAL_APPROVAL = 'CREDIT_ANALYSIS_AWAITING_COMMERCIAL_APPROVAL',
  COLLATERAL_ANALYSIS_IN_PROGRESS = 'COLLATERAL_ANALYSIS_IN_PROGRESS',
  COLLATERAL_ANALYSIS_AWAITING_APPROVAL = 'COLLATERAL_ANALYSIS_AWAITING_APPROVAL',
  COLLATERAL_ANALYSIS_WITH_COMMERCIAL = 'COLLATERAL_ANALYSIS_WITH_COMMERCIAL',
  COLLATERAL_ANALYSIS_PHASE_APPROVED = 'COLLATERAL_ANALYSIS_PHASE_APPROVED',
  COLLATERAL_ANALYSIS_PHASE_REJECTED = 'COLLATERAL_ANALYSIS_PHASE_REJECTED',
  CREDIT_ANALYSIS_APPROVED_CREDIT = 'CREDIT_ANALYSIS_APPROVED_CREDIT',
  CREDIT_ANALYSIS_REJECTED_CREDIT = 'CREDIT_ANALYSIS_REJECTED_CREDIT',
  INVESTMENT_FUND_ASSIGNMENT_PENDING_CONTRACT = 'INVESTMENT_FUND_ASSIGNMENT_PENDING_CONTRACT',
  INVESTMENT_FUND_ASSIGNMENT_AWAITING = 'INVESTMENT_FUND_ASSIGNMENT_AWAITING',
  INVESTMENT_FUND_ASSIGNMENT_WITH_COMMERCIAL = 'INVESTMENT_FUND_ASSIGNMENT_WITH_COMMERCIAL',
  INVESTMENT_FUND_ASSIGNMENT_SUBMITTED_MINUTA = 'INVESTMENT_FUND_ASSIGNMENT_SUBMITTED_MINUTA',

  // FLC
  EXTERNAL_CREDIT_NEW_NEGOTIATION = 'EXTERNAL_CREDIT_NEW_NEGOTIATION',
  EXTERNAL_CREDIT_IN_ANALYSIS = 'EXTERNAL_CREDIT_IN_ANALYSIS',
  EXTERNAL_CREDIT_ANALYSIS_SENT = 'EXTERNAL_CREDIT_ANALYSIS_SENT',

  // Luchesi
  EXTERNAL_LEGAL_NEW_NEGOTIATION = 'EXTERNAL_LEGAL_NEW_NEGOTIATION',
  EXTERNAL_LEGAL_IN_ANALYSIS = 'EXTERNAL_LEGAL_IN_ANALYSIS',
  EXTERNAL_LEGAL_PENDING_APPROVAL = 'EXTERNAL_LEGAL_PENDING_APPROVAL',
  CREDIT_LEAD_PENDENCIES_COMPLETED = 'CREDIT_LEAD_PENDENCIES_COMPLETED',
  CREDIT_LEAD_CPR_GENERATION = 'CREDIT_LEAD_CPR_GENERATION',
  CREDIT_LEAD_CPR_COMPLETED = 'CREDIT_LEAD_CPR_COMPLETED',
  CREDIT_LEAD_CPR_VALIDATION = 'CREDIT_LEAD_CPR_VALIDATION',
  CREDIT_LEAD_CPR_ASSIGNATION = 'CREDIT_LEAD_CPR_ASSIGNATION',

  // shared luchesi & internal
  P3_ACTIVATION_PENDING = 'P3_ACTIVATION_PENDING',
  GENERATE_DRAFT = 'GENERATE_DRAFT',
  AMENDMENT_CREATION = 'AMENDMENT_CREATION',
  AMENDMENT_SIGN_DIGITALLY = 'AMENDMENT_SIGN_DIGITALLY',
  AMENDMENT_SIGN_PHYSICALLY = 'AMENDMENT_SIGN_PHYSICALLY',
  REGISTERING = 'REGISTERING',
  DOCUMENTS_VALIDATION = 'DOCUMENTS_VALIDATION',
  DOCUMENTS_VALIDATION_CA = 'DOCUMENTS_VALIDATION_CA',
  DOCUMENTS_VALIDATION_CM = 'DOCUMENTS_VALIDATION_CM',
  AWAITING_PHYSICAL_DOCUMENTS = 'AWAITING_PHYSICAL_DOCUMENTS',

  // Luchesi & FLC
  ON_HOLD = 'ON_HOLD',

  // Terramagna
  TERRAMAGNA_NEW_CONTRACTS = 'TERRAMAGNA_NEW_CONTRACTS',
  TERRAMAGNA_IN_PROGRESS = 'TERRAMAGNA_IN_PROGRESS',
  TERRAMAGNA_COMPLETED = 'TERRAMAGNA_COMPLETED'
}

export type PillConfig = { [key in TabIds & HiddenTabIds]?: PillItem<PillIds>[] };

export const PILLS_CONFIG: PillConfig = {
  [TabIds.BACKGROUND_CHECK]: [
    { id: PillIds.BACKGROUND_CHECK_PENDING, text: textUtils.firstLetterUppercase(i18next.t('newCases')) },
    {
      id: PillIds.BACKGROUND_CHECK_MANAGERIAL_APPROVAL,
      text: textUtils.firstLetterUppercase(i18next.t('awaitingLeadApproval'))
    }
  ],
  [TabIds.CREDIT_ANALYSIS]: [
    { id: PillIds.CREDIT_ANALYSIS_IN_PROGRESS, text: textUtils.firstLetterUppercase(i18next.t('inAnalysis')) },
    {
      id: PillIds.CREDIT_ANALYSIS_AWAITING_APPROVAL,
      text: textUtils.firstLetterUppercase(i18next.t('awaitingAnalystApproval'))
    },
    {
      id: PillIds.CREDIT_ANALYSIS_WITH_COMMERCIAL,
      text: textUtils.firstLetterUppercase(i18next.t('withCommercial'))
    },
    {
      id: PillIds.CREDIT_ANALYSIS_APPROVED_CREDIT,
      text: textUtils.firstLetterUppercase(i18next.t('approvedCredit'))
    },
    {
      id: PillIds.CREDIT_ANALYSIS_REJECTED_CREDIT,
      text: textUtils.firstLetterUppercase(i18next.t('rejectedCredit'))
    }
  ],
  [TabIds.COLLATERAL_ANALYSIS]: [
    {
      id: PillIds.COLLATERAL_ANALYSIS_IN_PROGRESS,
      text: textUtils.firstLetterUppercase(i18next.t('inAnalysis'))
    },
    {
      id: PillIds.COLLATERAL_ANALYSIS_AWAITING_APPROVAL,
      text: textUtils.firstLetterUppercase(i18next.t('awaitingApproval'))
    },
    {
      id: PillIds.COLLATERAL_ANALYSIS_WITH_COMMERCIAL,
      text: textUtils.firstLetterUppercase(i18next.t('withCommercial'))
    },
    {
      id: PillIds.COLLATERAL_ANALYSIS_PHASE_APPROVED,
      text: textUtils.firstLetterUppercase(i18next.t('collateralApproved'))
    },
    {
      id: PillIds.COLLATERAL_ANALYSIS_PHASE_REJECTED,
      text: textUtils.firstLetterUppercase(i18next.t('collateralRejected'))
    }
  ],
  [TabIds.DOCUMENT_REGISTRATION]: [
    {
      id: PillIds.P3_ACTIVATION_PENDING,
      text: textUtils.firstLetterUppercase(i18next.t('docRegistrationActivationPending'))
    },
    { id: PillIds.GENERATE_DRAFT, text: textUtils.firstLetterUppercase(i18next.t('awaitingIssuance')) },
    { id: PillIds.REGISTERING, text: textUtils.firstLetterUppercase(i18next.t('draftEmitted')) },
    { id: PillIds.DOCUMENTS_VALIDATION, text: textUtils.firstLetterUppercase(i18next.t('awaitingValidation')) },
    { id: PillIds.DOCUMENTS_VALIDATION_CA, text: textUtils.firstLetterUppercase(i18next.t('awaitingForApproval')) },
    { id: PillIds.DOCUMENTS_VALIDATION_CM, text: textUtils.firstLetterUppercase(i18next.t('awaitingLeadApproval')) },
    {
      id: PillIds.CREDIT_ANALYSIS_WITH_COMMERCIAL,
      text: textUtils.firstLetterUppercase(i18next.t('withCommercial'))
    },
    { id: PillIds.AMENDMENT_CREATION, text: textUtils.firstLetterUppercase(i18next.t('awaitingAmendment')) },
    {
      id: PillIds.INVESTMENT_FUND_ASSIGNMENT_PENDING_CONTRACT,
      text: textUtils.firstLetterUppercase(i18next.t('validatedCases'))
    }
  ],
  [TabIds.DOCUMENT_REGISTRATION_SECRETARY]: [
    {
      id: PillIds.AMENDMENT_SIGN_PHYSICALLY,
      text: textUtils.firstLetterUppercase(i18next.t('awaitingPhysicalSignature'))
    }
  ],
  [HiddenTabIds.EXTERNAL_CREDIT]: [
    { id: PillIds.EXTERNAL_CREDIT_NEW_NEGOTIATION, text: textUtils.firstLetterUppercase(i18next.t('newNegotiation')) },
    { id: PillIds.EXTERNAL_CREDIT_IN_ANALYSIS, text: textUtils.firstLetterUppercase(i18next.t('inAnalysis')) },
    { id: PillIds.ON_HOLD, text: textUtils.firstLetterUppercase(i18next.t('withCommercial')) },
    { id: PillIds.EXTERNAL_CREDIT_ANALYSIS_SENT, text: textUtils.firstLetterUppercase(i18next.t('analysisConcluded')) }
  ],
  [TabIds.CONFIRMED_NEGOTIATIONS]: [
    { id: PillIds.EXTERNAL_LEGAL_NEW_NEGOTIATION, text: textUtils.firstLetterUppercase(i18next.t('newNegotiation')) },
    { id: PillIds.EXTERNAL_LEGAL_IN_ANALYSIS, text: textUtils.firstLetterUppercase(i18next.t('inAnalysis')) },
    {
      id: PillIds.ON_HOLD,
      text: textUtils.firstLetterUppercase(i18next.t('withCommercial'))
    }
  ],
  [TabIds.DOCUMENT_REGISTRATION_EXTERNAL]: [
    { id: PillIds.GENERATE_DRAFT, text: textUtils.firstLetterUppercase(i18next.t('awaitingIssuance')) },
    { id: PillIds.AMENDMENT_CREATION, text: textUtils.firstLetterUppercase(i18next.t('awaitingAmendment')) },
    { id: PillIds.REGISTERING, text: textUtils.firstLetterUppercase(i18next.t('draftEmitted')) },
    {
      id: PillIds.DOCUMENTS_VALIDATION,
      text: textUtils.firstLetterUppercase(i18next.t('awaitingValidation'))
    },
    {
      id: PillIds.AWAITING_PHYSICAL_DOCUMENTS,
      text: textUtils.firstLetterUppercase(i18next.t('awaitingPhysicalDocuments'))
    }
  ],
  [HiddenTabIds.TERRAMAGNA]: [
    { id: PillIds.TERRAMAGNA_NEW_CONTRACTS, text: textUtils.firstLetterUppercase(i18next.t('newContracts')) },
    { id: PillIds.TERRAMAGNA_IN_PROGRESS, text: textUtils.firstLetterUppercase(i18next.t('inProgress')) },
    {
      id: PillIds.CREDIT_ANALYSIS_WITH_COMMERCIAL,
      text: textUtils.firstLetterUppercase(i18next.t('withCommercial'))
    },
    { id: PillIds.TERRAMAGNA_COMPLETED, text: textUtils.firstLetterUppercase(i18next.t('finished')) }
  ],
  [HiddenTabIds.LEAD]: [
    {
      id: PillIds.LEAD_IN_BACKGROUND_CHECK,
      text: textUtils.firstLetterUppercase(i18next.t('creditLeadTab_BackgroundCheck'))
    },
    {
      id: PillIds.LEAD_IN_ANALYSIS,
      text: textUtils.firstLetterUppercase(i18next.t('creditLeadTab_CreditAnalysis'))
    },
    {
      id: PillIds.LEAD_IN_FORMALIZATION,
      text: textUtils.firstLetterUppercase(i18next.t('creditLeadTab_DocumentFormalization'))
    }
  ],
  [TabIds.CREDIT_LEAD_REPORT_INITIAL_ANALYSIS]: [
    {
      id: PillIds.BACKGROUND_CHECK_PENDING,
      text: textUtils.firstLetterUppercase(i18next.t('backgroundCheck_pending'))
    },
    { id: PillIds.BACKGROUND_CHECK_SENT, text: textUtils.firstLetterUppercase(i18next.t('sentCases')) },
    {
      id: PillIds.CREDIT_ANALYSIS_PENDING,
      text: textUtils.firstLetterUppercase(i18next.t('creditAnalysisPendingPillTitle'))
    }
  ],
  [TabIds.CREDIT_LEAD_FORMALIZATIONS]: [
    { id: PillIds.CREDIT_LEAD_CPR_GENERATION, text: textUtils.firstLetterUppercase(i18next.t('cprGeneration')) },
    { id: PillIds.CREDIT_LEAD_CPR_COMPLETED, text: textUtils.firstLetterUppercase(i18next.t('cprIssued')) },
    { id: PillIds.CREDIT_LEAD_CPR_VALIDATION, text: textUtils.firstLetterUppercase(i18next.t('cprValidation')) },
    { id: PillIds.CREDIT_LEAD_CPR_ASSIGNATION, text: textUtils.firstLetterUppercase(i18next.t('cprAssignation')) }
  ],
  [TabIds.CREDIT_LEAD_MONITORING]: [
    {
      id: PillIds.TERRAMAGNA_COMPLETED,
      text: textUtils.firstLetterUppercase(i18next.t('initialAnalysis'))
    }
  ]
};
